// Predefined Pine Script v5 Templates for Pine Editor

export const PINE_TEMPLATES = [
  {
    id: "msb_dynamic_indicator",
    name: "1. [Chỉ Báo] MSB Dynamic Structure (No Trades)",
    description: "Chỉ báo vẽ cấu trúc thị trường động Anchor -> MID -> SAME -> Break (Không vào lệnh giả lập)",
    code: `//@version=5
indicator("MSB Dynamic Structure", overlay=true, max_lines_count=500, max_labels_count=500)

// ========= Inputs =========
grp = "Cài Đặt Cấu Trúc"
windowBars    = input.int(150, "Cửa sổ cực trị dò Anchor", minval=50, maxval=400, group=grp)
lenPH         = input.int(3,  "Pivot High LEFT (dò Mid/H2)", minval=1, maxval=20, group=grp)
lenPL         = input.int(3,  "Pivot Low  LEFT (dò Mid/L2)", minval=1, maxval=20, group=grp)
r1            = input.float(1.0, "Tỷ lệ TP1 mục tiêu (1.0R)", minval=0.5, step=0.1, group=grp)
r2            = input.float(2.0, "Tỷ lệ TP2 mục tiêu (2.0R)", minval=1.0, step=0.1, group=grp)

grpSL = "SL & Buffer (Pips)"
slExtraOn      = input.bool(true, "Thêm SL Buffer từ SAME", group=grpSL)
slExtraPips    = input.float(5.0, "SL Buffer (Pips)", minval=0.0, group=grpSL)

// Hệ số Pips theo giá trị tài sản
pipMult = close < 5.0 ? 10000.0 : (close < 500.0 ? 100.0 : (close < 15000.0 ? 10.0 : 1.0))
slBuffer = slExtraOn ? (slExtraPips / pipMult) : 0.0

// Dò Pivot High / Low
ph = ta.pivothigh(high, lenPH, lenPH)
pl = ta.pivotlow(low, lenPL, lenPL)

// Trạng thái Anchor & Đỉnh Đáy
var float anchorHigh = na
var float anchorLow  = na
var float midBear    = na
var float sameBear   = na
var float midBull    = na
var float sameBull   = na

// Dò Đỉnh / Đáy cao nhất trong cửa sổ
highestWin = ta.highest(high, windowBars)
lowestWin  = ta.lowest(low, windowBars)

if high == highestWin
    anchorHigh := high
    midBear    := na
    sameBear   := na

if low == lowestWin
    anchorLow := low
    midBull   := na
    sameBull  := na

// Cập nhật cấu trúc Bearish (Sell)
if not na(anchorHigh)
    if not na(pl) and pl < anchorHigh and na(midBear)
        midBear := pl
    if not na(midBear) and not na(ph) and ph < anchorHigh and na(sameBear)
        sameBear := ph

    if not na(midBear) and not na(sameBear)
        if ta.crossunder(close, midBear)
            entryPrice = (high + low) / 2.0
            slPrice    = sameBear + slBuffer
            tp1Price   = entryPrice - (slPrice - entryPrice) * r1
            tp2Price   = entryPrice - (slPrice - entryPrice) * r2
            
            line.new(bar_index - 10, midBear, bar_index, midBear, color=color.blue, width=1)
            line.new(bar_index - 10, sameBear, bar_index, sameBear, color=color.purple, width=1)
            label.new(bar_index, midBear, "MSB Bear Break", color=color.blue, textcolor=color.white)
            
            midBear  := na
            sameBear := na

// Cập nhật cấu trúc Bullish (Buy)
if not na(anchorLow)
    if not na(ph) and ph > anchorLow and na(midBull)
        midBull := ph
    if not na(midBull) and not na(pl) and pl > anchorLow and na(sameBull)
        sameBull := pl

    if not na(midBull) and not na(sameBull)
        if ta.crossover(close, midBull)
            entryPrice = (high + low) / 2.0
            slPrice    = sameBull - slBuffer
            tp1Price   = entryPrice + (entryPrice - slPrice) * r1
            tp2Price   = entryPrice + (entryPrice - slPrice) * r2
            
            line.new(bar_index - 10, midBull, bar_index, midBull, color=color.blue, width=1)
            line.new(bar_index - 10, sameBull, bar_index, sameBull, color=color.purple, width=1)
            label.new(bar_index, midBull, "MSB Bull Break", color=color.blue, textcolor=color.white)
            
            midBull  := na
            sameBull := na
`
  },
  {
    id: "msb_dynamic_strategy",
    name: "2. [Chiến Lược] MSB Dynamic + 2TP Strategy (Backtest)",
    description: "Chiến lược giao dịch MSB Dynamic vào lệnh Limit, tính Winrate, TP1, TP2, SL và đo lường Backtest",
    code: `//@version=5
strategy("MSB Dynamic + 2TP Strategy", overlay=true, max_lines_count=500, max_labels_count=500)

// ========= Inputs =========
grp = "Settings"
windowBars    = input.int(150, "Cửa sổ cực trị (100–200)", minval=50, maxval=400, group=grp)
lenPH         = input.int(3,  "Pivot High LEFT (dò Mid/H2)", minval=1, maxval=20, group=grp)
lenPL         = input.int(3,  "Pivot Low  LEFT (dò Mid/L2)", minval=1, maxval=20, group=grp)
r1            = input.float(1.0, "Tỷ lệ TP1 (1.0R)", minval=0.5, step=0.1, group=grp)
r2            = input.float(2.0, "Tỷ lệ TP2 (2.0R)", minval=1.0, step=0.1, group=grp)

grpSL = "SL & Buffer (Pips)"
slFilterEnable = input.bool(true, "Bật lọc khoảng cách SL", group=grpSL)
slMinPips      = input.float(10.0, "SL Min (Pips)", minval=1.0, group=grpSL)
slMaxPips      = input.float(150.0, "SL Max (Pips)", minval=5.0, group=grpSL)
slExtraOn      = input.bool(true, "Thêm SL Buffer từ SAME", group=grpSL)
slExtraPips    = input.float(5.0, "SL Buffer (Pips)", minval=0.0, group=grpSL)
pendingTimeout = input.int(40, "Timeout hủy lệnh Limit (nến)", minval=5, maxval=200, group=grpSL)

pipMult = close < 5.0 ? 10000.0 : (close < 500.0 ? 100.0 : (close < 15000.0 ? 10.0 : 1.0))
slBuffer = slExtraOn ? (slExtraPips / pipMult) : 0.0

ph = ta.pivothigh(high, lenPH, lenPH)
pl = ta.pivotlow(low, lenPL, lenPL)

var float anchorHigh = na
var float anchorLow  = na
var float midBear    = na
var float sameBear   = na
var float midBull    = na
var float sameBull   = na

highestWin = ta.highest(high, windowBars)
lowestWin  = ta.lowest(low, windowBars)

if high == highestWin
    anchorHigh := high
    midBear    := na
    sameBear   := na

if low == lowestWin
    anchorLow := low
    midBull   := na
    sameBull  := na

if not na(anchorHigh)
    if not na(pl) and pl < anchorHigh and na(midBear)
        midBear := pl
    if not na(midBear) and not na(ph) and ph < anchorHigh and na(sameBear)
        sameBear := ph

    if not na(midBear) and not na(sameBear)
        if ta.crossunder(close, midBear)
            entryPrice = (high + low) / 2.0
            slPrice    = sameBear + slBuffer
            slDistPips = math.abs(entryPrice - slPrice) * pipMult
            
            if not slFilterEnable or (slDistPips >= slMinPips and slDistPips <= slMaxPips)
                tp1Price = entryPrice - (slPrice - entryPrice) * r1
                strategy.entry("SELL", strategy.short, limit=entryPrice)
                strategy.exit("TP1/SL", "SELL", limit=tp1Price, stop=slPrice)
            
            midBear  := na
            sameBear := na

if not na(anchorLow)
    if not na(ph) and ph > anchorLow and na(midBull)
        midBull := ph
    if not na(midBull) and not na(pl) and pl > anchorLow and na(sameBull)
        sameBull := pl

    if not na(midBull) and not na(sameBull)
        if ta.crossover(close, midBull)
            entryPrice = (high + low) / 2.0
            slPrice    = sameBull - slBuffer
            slDistPips = math.abs(entryPrice - slPrice) * pipMult
            
            if not slFilterEnable or (slDistPips >= slMinPips and slDistPips <= slMaxPips)
                tp1Price = entryPrice + (entryPrice - slPrice) * r1
                strategy.entry("BUY", strategy.long, limit=entryPrice)
                strategy.exit("TP1/SL", "BUY", limit=tp1Price, stop=slPrice)
            
            midBull  := na
            sameBull := na
`
  },
  {
    id: "ema_crossover_strategy",
    name: "3. [Chiến Lược] EMA Crossover + RSI Strategy",
    description: "Chiến lược giao cắt đường trung bình nhanh EMA 9 và chậm EMA 21 kết hợp bộ lọc động lượng RSI",
    code: `//@version=5
strategy("EMA Crossover + RSI Strategy", overlay=true)

// Inputs
fastLen    = input.int(9, "EMA Nhanh (Fast Length)", minval=1)
slowLen    = input.int(21, "EMA Chậm (Slow Length)", minval=1)
rsiPeriod  = input.int(14, "Chu kỳ RSI", minval=1)
rsiOverbought = input.int(70, "RSI Quá Mua", minval=50, maxval=90)
rsiOversold   = input.int(30, "RSI Quá Bán", minval=10, maxval=50)
rrRatio    = input.float(1.5, "Tỷ lệ R:R", step=0.1)

// Indicators
emaFast = ta.ema(close, fastLen)
emaSlow = ta.ema(close, slowLen)
rsiVal  = ta.rsi(close, rsiPeriod)
atrVal  = ta.atr(14)

plot(emaFast, "EMA Fast", color=color.aqua, linewidth=2)
plot(emaSlow, "EMA Slow", color=color.yellow, linewidth=2)

buyCond  = ta.crossover(emaFast, emaSlow) and rsiVal > 45 and rsiVal < rsiOverbought
sellCond = ta.crossunder(emaFast, emaSlow) and rsiVal < 55 and rsiVal > rsiOversold

if buyCond
    sl = close - atrVal * 1.5
    tp = close + (close - sl) * rrRatio
    strategy.entry("BUY", strategy.long)
    strategy.exit("TP/SL", "BUY", limit=tp, stop=sl)

if sellCond
    sl = close + atrVal * 1.5
    tp = close - (sl - close) * rrRatio
    strategy.entry("SELL", strategy.short)
    strategy.exit("TP/SL", "SELL", limit=tp, stop=sl)
`
  },
  {
    id: "supertrend_strategy",
    name: "4. [Chiến Lược] Supertrend Trend Strategy",
    description: "Bắt sóng theo xu hướng chuẩn Supertrend (ATR Multiplier & Period)",
    code: `//@version=5
strategy("Supertrend Strategy", overlay=true)

atrPeriod = input.int(10, "ATR Period", minval=1)
factor    = input.float(3.0, "Supertrend Multiplier", step=0.1)
riskReward = input.float(2.0, "Risk:Reward Ratio", step=0.1)

atr = ta.atr(atrPeriod)
upperBand = hl2 + factor * atr
lowerBand = hl2 - factor * atr

var float prevUpperBand = na
var float prevLowerBand = na
var int   direction = 1

prevLowerBand := nz(prevLowerBand[1], lowerBand)
prevUpperBand := nz(prevUpperBand[1], upperBand)

lowerBand := lowerBand > prevLowerBand or close[1] < prevLowerBand ? lowerBand : prevLowerBand
upperBand := upperBand < prevUpperBand or close[1] > prevUpperBand ? upperBand : prevUpperBand

direction := close > prevUpperBand ? 1 : (close < prevLowerBand ? -1 : nz(direction[1], 1))
superTrend = direction == 1 ? lowerBand : upperBand

plot(superTrend, "Supertrend", color=direction == 1 ? color.green : color.red, linewidth=2)

if ta.change(direction) and direction == 1
    sl = superTrend
    tp = close + math.abs(close - sl) * riskReward
    strategy.entry("BUY", strategy.long)
    strategy.exit("TP/SL", "BUY", limit=tp, stop=sl)

if ta.change(direction) and direction == -1
    sl = superTrend
    tp = close - math.abs(sl - close) * riskReward
    strategy.entry("SELL", strategy.short)
    strategy.exit("TP/SL", "SELL", limit=tp, stop=sl)
`
  },
  {
    id: "blank_indicator",
    name: "5. [Mẫu Trống] Khung Chỉ Báo Tùy Chỉnh (Indicator)",
    description: "Khung mẫu chỉ báo kỹ thuật cơ bản (chỉ vẽ đường, không đặt lệnh)",
    code: `//@version=5
indicator("My Custom Indicator", overlay=true)

// Nhập thông số
length = input.int(20, "Chu kỳ EMA")

// Tính toán chỉ báo
emaVal = ta.ema(close, length)

// Vẽ lên biểu đồ
plot(emaVal, "My EMA", color=color.aqua, linewidth=2)
`
  }
];
